<template>
    <div>
        <!-- Total Active Members -->
        <div class="col-md-12 border-0 mb-4">
            <div class="ibox-title company-form-box-title gf-contribution card-highlight">
                <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <div class="text-muted card-label">Total Active Members</div>
                        <div class="card-number">{{ gf_membership_status.total_active_employees }}</div>
                    </div>
                    <div class="d-flex align-items-center">
                        <i class="fa fa-users text-primary card-icon"></i>
                    </div>
                </div>
            </div>
        </div>

        <!-- Male/Female -->
        <div class="col-md-12 border-0 mb-4">
            <div class="row">
                <!-- Male -->
                <div class="col-md-4 border-0">
                    <div class="ibox-title company-form-box-title gf-contribution card-light">
                        <div class="d-flex align-items-center">
                            <div>
                                <div class="d-flex align-items-baseline">
                                    <span class="gender-label">Male</span>
                                </div>
                                <div class="gender-number">{{ gf_membership_status.total_male }}</div>
                                <span class="gender-percentage">{{ gf_membership_status.total_male_percentage }}%</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Female -->
                <div class="col-md-4">
                    <div class="ibox-title company-form-box-title gf-contribution card-light">
                        <div class="d-flex align-items-center">
                            <div>
                                <div class="d-flex align-items-baseline">
                                    <span class="gender-label">Female</span>
                                </div>
                                <div class="gender-number">{{ gf_membership_status.total_female }}</div>
                                <span class="gender-percentage">{{ gf_membership_status.total_female_percentage }}%</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Other -->
                <div class="col-md-4">
                    <div class="ibox-title company-form-box-title gf-contribution card-light">
                        <div class="d-flex align-items-center">
                            <div>
                                <div class="d-flex align-items-baseline">
                                    <span class="gender-label">Others</span>
                                </div>
                                <div class="gender-number">{{ gf_membership_status.total_other }}</div>
                                <span class="gender-percentage">{{ gf_membership_status.total_other_percentage }}%</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-12 border-0 mb-4">
            <div class="ibox-title company-form-box-title gf-contribution card-highlight">
                <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <div class="text-muted card-label">Awaiting Settlement</div>
                        <div class="card-number">{{ gf_membership_status.total_awaiting_employee }}</div>
                    </div>
                    <div class="d-flex align-items-center">
                        <i class="fa fa-user-times text-primary card-icon"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GFMembershipStatusChart',
    props: ['gf_membership_status'],
}
</script>

<style scoped>
/* Card Styles */
.card-highlight {
    background-color: #a0ded7;
    border-radius: 8px;
    padding: 20px;
}

.card-light {
    background-color: #e6f7f4;
    border-radius: 8px;
    padding: 20px;
}

.card-label {
    font-size: 15px;
}

.card-number {
    font-size: 24px;
    font-weight: bold;
}

.card-icon {
    font-size: 36px;
}

/* Gender styles */
.gender-label {
    font-size: 15px;
    font-weight: 600;
}

.gender-number {
    font-size: 24px;
    font-weight: bold;
}

.gender-percentage {
    font-size: 14px;
    color: gray;
    margin-right: 6px;
}
</style>
